import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
/**
 * Created by Alican Köker on 2018-06-28.
 */
import {FruitsHelper} from "../../utils/FruitsHelper";
import {Fruits} from "../../Fruits";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export interface IWinLineConfig {
    lineThickness?:number,
    circleSize?:number,
    baseColor?:number,
    outlineColor?:number,
    dynamicColor?:boolean,
    dynamicColors?:number[],
}

export class WinLine extends PIXI.Container {
    private _orientation:string = Orientation.LANDSCAPE;

    constructor(orientation:string) {
        super();
        this._orientation = orientation;
    }

    public strokeWinningline(lineData:number[], lineNumber:number, lineConfig:IWinLineConfig = {}):void {

        let outlineThickness:number = lineConfig.lineThickness ? lineConfig.lineThickness : 14;
        let lineThickness:number = outlineThickness * .8;
        let outerCircleLineSize:number = lineConfig.circleSize ? lineConfig.circleSize : lineThickness * .68;
        let innerCircleSize:number = outerCircleLineSize * .75;
        let baseColor:number = lineConfig.baseColor ? lineConfig.baseColor : 0x000000;
        let outlineColor:number = lineConfig.outlineColor ? lineConfig.outlineColor : 0XFFFFFF;

        //if dynamic colors are specified in an array, iterates through color array. otherwise multiplies base color by line number to create different color for each line
        let lineColor:number = lineConfig.dynamicColor ? lineConfig.dynamicColors ? WinLine.getLineColor(baseColor, lineNumber, lineConfig.dynamicColors) : WinLine.getLineColor(baseColor, lineNumber) : baseColor;

        let outlineCont:PIXI.Container = new PIXI.Container();
        this.addChild(outlineCont);
        let lineCont:PIXI.Container = new PIXI.Container();
        this.addChild(lineCont);


        let circlePos:number[] = FruitsHelper.getSymbolPosition(0, lineData[0], this._orientation);

        if(lineConfig.outlineColor) outlineCont.addChild(WinLine.drawCircle(outerCircleLineSize * .9, circlePos[0] + 1, circlePos[1], outlineColor));
        outlineCont.addChild(WinLine.drawCircle(innerCircleSize * .9, circlePos[0] + 1, circlePos[1], lineColor));

        for(let i:number = 1; i < lineData.length; i++) {
            let circlePos:number[] = FruitsHelper.getSymbolPosition(i, lineData[i], this._orientation);
            if(lineConfig.outlineColor) outlineCont.addChild(WinLine.drawCircle(outerCircleLineSize, circlePos[0], circlePos[1], outlineColor));
            outlineCont.addChild(WinLine.drawCircle(innerCircleSize, circlePos[0], circlePos[1], lineColor));
        }

        for(let i:number = 1; i < lineData.length; i++) {

            let lineFrom:number[] = FruitsHelper.getSymbolPosition(i - 1, lineData[i - 1], this._orientation);
            let lineTo:number[] = FruitsHelper.getSymbolPosition(i, lineData[i], this._orientation);

            if(lineConfig.outlineColor) {
                let lineStroke:PIXI.Graphics = new PIXI.Graphics();
                lineStroke.lineStyle(outlineThickness, outlineColor);
                lineStroke.moveTo(lineFrom[0], lineFrom[1]);
                lineStroke.lineTo(lineTo[0], lineTo[1]);
                outlineCont.addChild(lineStroke);
            }


            let line:PIXI.Graphics = new PIXI.Graphics();

            line.lineStyle(lineThickness, lineColor);
            line.moveTo(lineFrom[0], lineFrom[1]);
            line.lineTo(lineTo[0], lineTo[1]);
            lineCont.addChild(line);
        }
    }

    public drawWinningLine(lineData:number[], lineNumber:number, lineConfig:IWinLineConfig = {}):PIXI.Container {
        let outlineThickness:number = lineConfig.lineThickness ? lineConfig.lineThickness : 14;
        let lineThickness:number = outlineThickness * .8;
        let outerCircleLineSize:number = lineConfig.circleSize ? lineConfig.circleSize : lineThickness * .68;
        let innerCircleSize:number = outerCircleLineSize * .75;
        let baseColor:number = lineConfig.baseColor ? lineConfig.baseColor : 0x000000;
        let outlineColor:number = lineConfig.outlineColor ? lineConfig.outlineColor : 0XFFFFFF;

        //if dynamic colors are specified in an array, iterates through color array. otherwise multiplies base color by line number to create different color for each line
        let lineColor:number = lineConfig.dynamicColor ? lineConfig.dynamicColors ? WinLine.getLineColor(baseColor, lineNumber, lineConfig.dynamicColors) : WinLine.getLineColor(baseColor, lineNumber) : baseColor;

        let outlineCont:PIXI.Container = new PIXI.Container();
        this.addChild(outlineCont);
        let lineCont:PIXI.Container = new PIXI.Container();
        this.addChild(lineCont);

        let circlePos:number[] = FruitsHelper.getSymbolPosition(0, lineData[0], this._orientation);

        if(lineConfig.outlineColor) outlineCont.addChild(WinLine.drawCircle(outerCircleLineSize * .9, circlePos[0] + 1, circlePos[1], outlineColor));
        outlineCont.addChild(WinLine.drawCircle(innerCircleSize * .9, circlePos[0] + 1, circlePos[1], lineColor));


        for(let i:number = 1; i < lineData.length; i++) {
            let circlePos:number[] = FruitsHelper.getSymbolPosition(i, lineData[i], this._orientation);
            if(lineConfig.outlineColor) outlineCont.addChild(WinLine.drawCircle(outerCircleLineSize, circlePos[0], circlePos[1], outlineColor));
            outlineCont.addChild(WinLine.drawCircle(innerCircleSize, circlePos[0], circlePos[1], lineColor));
        }

        for(let i:number = 1; i < lineData.length; i++) {

            let lineFrom:number[] = FruitsHelper.getSymbolPosition(i - 1, lineData[i - 1], this._orientation);
            let lineTo:number[] = FruitsHelper.getSymbolPosition(i, lineData[i], this._orientation);

            if(lineConfig.outlineColor) {
                let lineStroke:PIXI.Graphics = new PIXI.Graphics();
                lineStroke.lineStyle(outlineThickness, outlineColor);
                lineStroke.moveTo(lineFrom[0], lineFrom[1]);
                lineStroke.lineTo(lineTo[0], lineTo[1]);
                outlineCont.addChild(lineStroke);
            }


            let line:PIXI.Graphics = new PIXI.Graphics();

            line.lineStyle(lineThickness, lineColor);
            line.moveTo(lineFrom[0], lineFrom[1]);
            line.lineTo(lineTo[0], lineTo[1]);

            lineCont.addChild(line);
        }

        return lineCont;
    }

    private static getLineColor(baseColor:number, lineNumber:number, dynamicColorArr?:number[]):number {
        if(dynamicColorArr)
            return dynamicColorArr[lineNumber! % dynamicColorArr!.length];
        else
            return baseColor * lineNumber!;
    }

    private static drawCircle(radius:number, x:number, y:number, color:number):PIXI.Graphics {
        let circle:PIXI.Graphics = new PIXI.Graphics();

        circle.beginFill(color);
        circle.drawCircle(x, y, radius);
        circle.endFill();

        circle.pivot.set(0.5, 0.5);

        return circle;
    }
}

export class WinText extends PIXI.Container {

    private readonly _text:PIXI.BitmapText;

    constructor(data:IBetLineWinData) {
        super();

        this._text = new PIXI.BitmapText(`${Fruits.api.currency.formatValue(data.multipliedAmount)}`, {
            fontName : "WinNumbersBM",
            fontSize : 14,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        (<PIXI.Point>this._text.anchor).set(0.5, 0.5);
        this._text.letterSpacing = -20;
        this._text.y = -20;
        this.addChild(this._text);
    }
}